<template>
  <div id="app">
    <router-view />
    
    <!-- 全局悬浮窗 -->
    <floating-window
      v-if="showFloatingWindow"
      @close="showFloatingWindow = false"
     src="./assets/img/ai.jpeg"/>
  </div>
</template>

<script>
import FloatingWindow from '@/components/FloatingWindow.vue';
export default {
  components: {
    FloatingWindow
  },
  data() {
    return {
      showFloatingWindow: true
    }
  }
}
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
  overflow: auto;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
